var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayWhiteBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9993 42.6663C16.8118 42.6663 9.33268 35.1871 9.33268 25.9996C9.33268 16.8121 16.8118 9.33296 25.9993 9.33296C35.1868 9.33296 42.666 16.8121 42.666 25.9996C42.666 35.1871 35.1868 42.6663 25.9993 42.6663ZM25.9993 5.16629C23.2635 5.16629 20.5544 5.70516 18.0268 6.75213C15.4992 7.79911 13.2025 9.33368 11.268 11.2682C7.36095 15.1752 5.16602 20.4743 5.16602 25.9996C5.16602 31.525 7.36095 36.824 11.268 40.731C13.2025 42.6656 15.4992 44.2001 18.0268 45.2471C20.5544 46.2941 23.2635 46.833 25.9993 46.833C31.5247 46.833 36.8237 44.638 40.7307 40.731C44.6377 36.824 46.8327 31.525 46.8327 25.9996C46.8327 23.2637 46.2938 20.5547 45.2468 18.027C44.1999 15.4994 42.6653 13.2028 40.7307 11.2682C38.7962 9.33368 36.4995 7.79911 33.9719 6.75213C31.4443 5.70516 28.7352 5.16629 25.9993 5.16629ZM21.8327 35.3746L34.3327 25.9996L21.8327 16.6246V35.3746Z",
    fill: "#1CB19B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayWhiteBg);
export default __webpack_public_path__ + "static/media/play-white-bg.bee110c5b0298fb2edf5ad3d0f9c4d1e.svg";
export { ForwardRef as ReactComponent };